import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  userPoolId: null,
  loginDomain: null,
  auth: null,
  challengeName: null,
  challengeUser: null,
  profile: null,
  permissions: null,
  prefillData: null,
};

export default {
  state,
  getters,
  mutations,
  actions,
};
